import request from "@utils/request";

export function getLoginGroupChange(query) {
    return request({
        url: "login/group-change",
        method: "get",
        params: query
    });
}
